import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { greys } from "@clockwise/web-commons/src/styles/color.styles";

export const header: CSSProperties = {
  marginBottom: 15,
};

export const styles = {
  labelRoot: {
    color: greys.slate,
    fontSize: 14,
    lineHeight: 1.4,
  },
  labelOtherRoot: {
    marginRight: 0,
    color: greys.slate,
    fontSize: 14,
    lineHeight: 1.4,
  },
  labelInputRoot: {
    color: greys.slate,
  },
};
